import { render, staticRenderFns } from "./htmlblock.vue?vue&type=template&id=d5babc9a&"
import script from "./htmlblock.vue?vue&type=script&lang=js&"
export * from "./htmlblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports